module.exports = __webpack_public_path__ + "img/FloorPiano.b6dcea97.webp";